module.exports = __webpack_public_path__ + "img/cat-rental-logo.3f655ff9.jpg";